import { render, staticRenderFns } from "./incidenciasHandler.vue?vue&type=template&id=6d72f6cb&"
import script from "./incidenciasHandler.vue?vue&type=script&lang=ts&"
export * from "./incidenciasHandler.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports